import BackIcon from 'assets/images/rectangle/east.svg'
import classNames from 'classnames'
import { useLocation, useNavigate } from 'react-router-dom'
interface IHeaderProps {
    title: string
}
export default function Header({ title }: IHeaderProps) {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const isCallback = pathname.includes('gateway-callback/')
    return (
        <div
            className={classNames(
                ' w-full px-2 py-3 flex sticky top-0 z-10  items-center',
                !isCallback ? 'justify-between' : 'justify-center'
            )}
        >
            {!isCallback && (
                <img
                    src={BackIcon}
                    alt="back"
                    onClick={() => navigate(-1)}
                    className=" cursor-pointer"
                />
            )}
            <p className=" font-black text-xl">{title}</p>
            <div></div>
        </div>
    )
}
